
import CarouselImage from "./CarouselImage";

export default {
  components: { CarouselImage },

  props: {
    gallery: { type: Array, default: () => {} },
    index: { type: Number, default: 0 },
    primary: { type: Object, default: () => {} },
    getImage: { type: Function, default: () => {} },
  },

  data() {
    return { dataIndex: this.index, text: {} };
  },

  computed: {
    slideVisible() {
      return this.gallery[this.dataIndex];
    },
  },

  methods: {
    clickSwiper(index) {
      if (this.$refs["carousel-image"]) {
        this.$refs["carousel-image"].imageIndex = 0;
      }

      if (this.dataIndex == 0 && index == -1) {
        this.dataIndex = this.gallery.length - 1;
      } else {
        this.dataIndex = (this.dataIndex + index) % this.gallery.length;
      }
    },
  },
};
